import { IApiError } from '@/models/apiError.model';
import { IAdminProfile } from '@/models/admins.model';

export const ADMIN_PROFILE_SLICE_NAME = 'adminProfile';

export interface AdminProfileState {
  profile: IAdminProfile | null;
  isLoading: boolean;
  error: IApiError | null;
}

export const initialState: AdminProfileState = {
  profile: null,
  isLoading: false,
  error: null,
};
